import type { AnyError } from "#public"
import type { Result } from "#public"

import { Failure } from "./Failure"

// Map over a result: on success run `success`; on failure run `error` (which
// defaults to passing the original error through). The error union accumulates —
// `Result<T, E1>` mapped with a `success` returning `Result<G, E2>` yields
// `Result<G, E1 | E2>`.
export const ResultMap = <T, G, E1 extends AnyError, E2 extends AnyError>(
  result: Result<T, E1>,
  success: (value: T) => Result<G, E2>,
  error: (e: E1) => Result<G, E2> = Failure
): Result<G, E2> => (result.error ? error(result.error) : success(result.value as T))
